<template>
    <v-row></v-row>
</template>
<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
// import getHealthpointLevel from "../data/getHealthPointLevel";
// import bqGetHealthPointLevel from "../data/bqGetHealthPointLevel";
// import scriptForUpdateHealthData from "../data/scriptForUpdateHealthData";
// import scriptForUpdateChallengeData from "../data/scriptForUpdateChallengeData";
// import scriptForUpdateOnsite from "../data/scriptForUpdateOnsite";
// import scriptForProgramMemberData from "../data/scriptForProgramMemberData";
// import scriptForUpdateProgramMember from "../data/scriptForUpdateProgramMember";
// import scriptForUpdateOnsiteV2 from "../data/scriptForUpdateOnsiteV2";
import scriptForUpdateGroupId from "../data/scriptForUpdateGroupId";
export default {
    data() {
        return {}
    },
    created() {
        var vm = this;
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
    },
    methods: {
        initialize() {
            // bqGetHealthPointLevel();
            // scriptForUpdateHealthData();
            // scriptForUpdateChallengeData();
            // scriptForUpdateOnsite();
            // scriptForUpdateProgramMember();
            // scriptForUpdateOnsiteV2();
            // scriptForProgramMemberData();
            scriptForUpdateGroupId();
        }
    }
};
</script>